import React from 'react';
import { Navigate } from 'react-router-dom';

import { ErrorPage } from 'app/ErrorHandling';

import { AlertFormPage } from './AlertFormPage';
import { AlertViewPage } from './AlertViewPage';
import { AssignRoutesPage } from './AssignRoutesPage';
import { AssignRoutesSubPage } from './AssignRoutesSubPage';
import { ManageAlerts } from './ManageAlerts';
import { NotificationLog } from './NotificationLog/NotificationLog';
import { useNotificationProject } from './useNotificationProject';

function NotificationsIndexRedirect() {
  const { projectSlug } = useNotificationProject();
  if (!projectSlug) {
    return null;
  }
  return <Navigate to={`log/${projectSlug}`} replace />;
}

export function notificationsRoutes() {
  const routes = [
    {
      path: '',
      element: <NotificationsIndexRedirect />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'log/:projectSlug',
      element: <NotificationLog />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'manage/:projectSlug',
      element: <ManageAlerts />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'manage/:projectSlug/new',
      element: <AlertFormPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'manage/:projectSlug/:alertId/edit',
      element: <AlertFormPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'manage/:projectSlug/:alertId',
      element: <AlertViewPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'routes/:projectSlug',
      element: <AssignRoutesPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'routes/:projectSlug/:routeId/assign',
      element: <AssignRoutesSubPage />,
      errorElement: <ErrorPage />,
    },
  ];
  return routes;
}
